import React from 'react'
import { AppProvider } from './contexts/AppContext'
import HomePage from './pages/HomePage'
import './App.css'

/**
 * Hong Kong Bank Code Directory - Main Application Component
 * 
 * @description Comprehensive directory of 127 HKMA-licensed Hong Kong banks
 * @keywords Hong Kong banks, bank codes, clearing codes, HKMA, virtual banks
 * @version 2026.03.04
 * @author Homy Tech Limited
 * @see https://hkbankcodes.homy.hk
 */
function App() {
  return (
    <AppProvider>
      <HomePage />
    </AppProvider>
  )
}

export default App